import { EventListItem } from '../types/events.types';

import { EventCard } from './EventCard';
import { NoResults } from './NoResults';

type EventsListProps = {
  events: EventListItem[];
  columns?: {
    mobile?: 1 | 2;
    tablet?: 2 | 3;
    desktop?: 3 | 4;
  };
};

const getGridColumnsClass = (mobile: 1 | 2, tablet: 2 | 3, desktop: 3 | 4) => {
  const mobileClass = mobile === 1 ? 'tw-grid-cols-1' : 'tw-grid-cols-2';
  const tabletClass = tablet === 2 ? 'min-[775px]:tw-grid-cols-2' : 'min-[775px]:tw-grid-cols-3';
  const mediumDesktopClass = 'min-[1173px]:tw-grid-cols-3';
  const largeDesktopClass = desktop === 4 ? 'min-[1570px]:tw-grid-cols-4' : '';

  return `${mobileClass} ${tabletClass} ${mediumDesktopClass} ${largeDesktopClass}`.trim();
};

export const EventsList = ({ events, columns = { mobile: 1, tablet: 2, desktop: 4 } }: EventsListProps) => {
  if (events.length === 0) {
    return <NoResults />;
  }

  const mobile = columns.mobile ?? 1;
  const tablet = columns.tablet ?? 2;
  const desktop = columns.desktop ?? 4;

  return (
    <div className={`tw-grid tw-gap-6 ${getGridColumnsClass(mobile, tablet, desktop)}`}>
      {events.map((event) => (
        <EventCard key={event.id} event={event} />
      ))}
    </div>
  );
};
